// removed by extract-text-webpack-plugin
module.exports = {"link":"B7YLDH4x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.pcss
// module id = 736
// module chunks = 0